﻿export default class ContactDetails {
    constructor() {
        this.dom = {
            $: window.$,
            language: $('html').attr('lang')
        };
        this.init();
    }
    init() {
        let thisDom = this.dom;

        switch (thisDom.language) {
            case 'pl':
                // code block
                break;
            case 'ro':
                // code block
                this.autoCheckbox();
                break;
            default:
            // code block
        }

    }

    autoCheckbox() {
        $('.form-row.d-none').find('input[type=checkbox]').prop('checked', $('[data-validator-id="agree-1"]').prop('checked'));

        $('body').on('change', '[data-validator-id="agree-1"]', function () {
            $('.form-row.d-none').find('input[type=checkbox]').prop('checked', $(this).prop('checked'))
        });    
    }
}

document.addEventListener('DOMContentLoaded', () => new ContactDetails());